import { Button } from 'ypf-pas-general-ui-components';

import './TermsOfService.scss';

const handleClose = () => {
  window.close();
};

const TermsOfService = () => (
  <div className="pas-container">
    <div className="container-main-title">
      <div className="tos-main-title">
        <h2 className="pas-title">
          Términos y Condiciones de Uso Aceptable de GPT Empresarial en Y-click!
        </h2>
      </div>
    </div>

    <div className="style-content">
      <h3 className="tos-title">Condiciones Generales</h3>
      <p className="tos-txt">
        Este documento de términos de uso aceptable de GPT Empresarial tiene como objetivo
        establecer las pautas y directrices para el uso adecuado y responsable del sistema de
        inteligencia artificial basado en lenguaje natural proporcionado por YPF S.A. (en adelante,
        indistintamente, YPF S.A. y/o la Compañía). Al emplear esta herramienta y su lenguaje
        natural, los usuarios reconocen su compromiso de cumplir con los términos y condiciones
        detallados a continuación.
      </p>
      <p className="tos-txt">
        GPT Empresarial es un sistema de inteligencia artificial basado en un modelo de
        procesamiento que interpreta y genera contenido en lenguaje natural, que permite a los
        usuarios interactuar con el fin de obtener información determinada y asistencia relacionada
        a un tema específico.
      </p>
      <p className="tos-txt">
        Los presentes Términos y Condiciones corresponden al uso de GPT Empresarial, en adelante
        GAIA, utilizado en la aplicación Y-click! que responderá a los usuarios consultas vinculadas
        a su funcionamiento.
      </p>

      <p className="tos-txt">
        La base de contenido que utilizará GAIA corresponde a documentos de propiedad de YPF S.A.,
        que recopilan procedimientos, preguntas y situaciones de consulta frecuente para la
        utilización del producto Y-click!.
      </p>
      <p className="tos-txt">
        La utilización de GAIA será exclusiva para los usuarios de Y-click! debidamente aprobados
        incorporados a la misma mediante los protocolos de ciberseguridad correspondientes de YPF
        S.A. para usuarios internos y externos.
      </p>
      <h3 className="tos-title">Uso Apropiado</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            GAIA debe ser empleado exclusivamente con propósitos relacionados con el objeto de la
            herramienta Y-click!.
          </li>
          <li>
            Los usuarios deben comunicarse de manera profesional, considerada y respetuosa al
            interactuar con GAIA.
          </li>
          <li>
            Se prohíbe categóricamente el uso de GAIA para actividades ilegales, discriminatorias,
            difamatorias o que pudieran afectar la reputación y los valores de la compañía, o
            cualquier otra actividad que contradiga el Código de Ética y Conducta de la YPF SA.
          </li>
          <li>
            Está estrictamente prohibida la generación o difusión de contenido confidencial,
            inapropiado, ofensivo o engañoso mediante GAIA.
          </li>
          <li>
            En el caso de usuarios que sean empleados de YPF S.A., la utilización de GAIA estará
            también alcanzada por la norma vigente de &quot;Uso Aceptable de Activos Informáticos y
            de Información&quot;.
          </li>
        </ul>
      </p>

      <h3 className="tos-title">Confidencialidad y Protección de Datos</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            Las respuestas provistas por GAIA deben ser tratadas por todos los usuarios de la
            herramienta Y-click! como información confidencial y no podrán ser divulgadas por fuera
            de la Compañía ni fuera del marco del servicio que se preste a la misma.
          </li>
          <li>
            En caso de que las respuestas provistas por GAIA o bien la información proporcionada por
            los usuarios contengan datos personales, resultará aplicable lo dispuesto por Ley de
            Protección de Datos Personales 25.326 y su normativa complementaria.
          </li>
        </ul>
      </p>
      <h3 className="tos-title">Responsabilidad</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            GAIA es una herramienta que no posee autodeterminación y no otorga mandato a los efectos
            del proceso de toma de decisión, recayendo la responsabilidad exclusiva sobre el
            usuario.
          </li>
        </ul>
      </p>
      <h3 className="tos-title">Seguridad de la Información</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            Se informa a los usuarios que las conversaciones realizadas a través de este modelo de
            lenguaje serán almacenadas y podrán ser monitoreadas con el objetivo de garantizar la
            seguridad y el cumplimiento de las normas que pudieren corresponder.
          </li>
          <li>
            El uso de la información debe estar alineado con la Política de Ciberseguridad y
            Seguridad Corporativa de la Compañía y/u otras que resulten aplicables en materia de
            clasificación de activos de la información.
          </li>
          <li>
            GAIA respeta la privacidad del usuario y utiliza los datos que este le proporciona en
            cada interacción para generar una respuesta acorde con la consulta, pedido o
            instrucción.
          </li>
        </ul>
      </p>
      <h3 className="tos-title">Detección de Errores, Sesgos y Problemas Éticos</h3>
      <p className="tos-txt">
        Los usuarios tienen la responsabilidad de informar de inmediato sobre cualquier error, sesgo
        o eventual dilema ético que identifiquen en las respuestas generadas por GAIA dirigiéndose a
        <a className="tos-mail" href="mailto:contactoIA@ypf.com">
          {' '}
          contactoIA@ypf.com
        </a>
        .
      </p>

      <h3 className="tos-title">Derechos de Propiedad Intelectual</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            Las respuestas generadas por GAIA son propiedad exclusiva de YPF, cualquiera sea el
            origen de los datos, excepto en casos donde las respuestas contengan datos personales,
            en conformidad con la Ley de Protección de Datos Personales 25.326.
          </li>
        </ul>
      </p>

      <h3 className="tos-title">Cumplimiento Legal y Regulatorio</h3>
      <p className="tos-txt">
        <ul className="tos-list">
          <li>
            Al utilizar GAIA, los usuarios se comprometen a cumplir con la normativa aplicable y/o
            la que eventualmente en el futuro la reemplace.
          </li>
          <li>
            La Compañía se reserva el derecho de proporcionar información relativa a las
            interacciones con GAIA y la eventual necesidad de dar respuesta a organismos por
            solicitudes derivadas de normas legales y regulatorias.
          </li>
        </ul>
      </p>
      <h3 className="tos-title">Incumplimiento y Consecuencias</h3>
      <p className="tos-txt">
        La Compañía podrá aplicar sanciones disciplinarias en caso de incumplimiento de la presente
        política por parte de usuario internos. Para el caso de usuarios externos podrán ser de
        aplicación las medidas/recursos contractuales previstos en cada caso a tales efectos.
      </p>
      <h3 className="tos-title">Aceptación de Términos</h3>
      <p className="tos-txt">
        Al hacer uso de GAIA, los usuarios manifiestan haber leído, comprendido y aceptado
        plenamente los términos y condiciones especificados en esta política. YPF S.A. se reserva el
        derecho de actualizar o modificar estos Términos y Condiciones de Uso Aceptable en cualquier
        momento.
      </p>
      <footer className="tos-footer">
        <Button
          fontSizeLabel="16px"
          label="Salir"
          onClick={handleClose}
          type="button"
          variant="primary"
        />
      </footer>
    </div>
  </div>
);

export default TermsOfService;
